/**
 * City Structured Data Component
 * Renders LocalBusiness, Service, and Breadcrumb schemas for city pages
 */

import React from 'react';
import Head from 'next/head';
import { generateAllSchemas } from '../../utils/seoHelpers';

interface CityStructuredDataProps {
  city: string;
  turfCount: number;
  areaName?: string | null;
  areaSlug?: string | null;
}

const CityStructuredData: React.FC<CityStructuredDataProps> = ({ city, turfCount, areaName, areaSlug }) => {
  const schemas = generateAllSchemas(city, turfCount, areaName, areaSlug);

  // If city not found, don't render anything
  if (!schemas.localBusiness) {
    return null;
  }

  return (
    <Head>
      {/* LocalBusiness Schema */}
      {schemas.localBusiness && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schemas.localBusiness)
          }}
        />
      )}

      {/* Service Schema */}
      {schemas.service && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schemas.service)
          }}
        />
      )}

      {/* Breadcrumb Schema */}
      {schemas.breadcrumb && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schemas.breadcrumb)
          }}
        />
      )}
    </Head>
  );
};

export default CityStructuredData;
